import { useEffect, useState } from "react";
import { getGoogleSSOLink } from "../utils/data-fetching/getGoogleSSOLink";

interface UseGoogleSSOProps {
  applicationId: string | null | undefined;
}

function useGoogleSSO({ applicationId }: UseGoogleSSOProps) {
  const [googleSSOUrl, setGoogleSSOUrl] = useState<URL | null>(null);

  useEffect(() => {
    if (applicationId) {
      const fetchGoogleSSOUrl = async () => {
        try {
          const result = await getGoogleSSOLink({ applicationId });
          document.cookie = `RPSID=${result?.rpsid}; Path=/; Domain=treez.io; Secure; SameSite: None`;
          const resultUrlFormat = new URL(result?.location);
          setGoogleSSOUrl(resultUrlFormat);
        } catch (error) {
          setGoogleSSOUrl(null);
        }
      };
      fetchGoogleSSOUrl();
    }
  }, [applicationId]);

  return { googleSSOUrl };
}

export default useGoogleSSO;
